import { useContext } from "react"

import { useLanguage } from "@languages/index"
import { CampaignFormContext } from "../../../../campaignForm.context"
import CampaignFormModificationGuide from "../campaignFormModificationGuide/campaignFormModificationGuide"
import CampaignFormPastCampaignsModal from "./components/campaignFormPastCampaignsModal/campaignFormPastCampaignsModal"
import CampaignFormHeaderButton from "./components/campaignFormHeaderButton/campaignFormHeaderButton"
import { isJapanService } from "constants/domains/domains"

const CampaignFormHeader = () => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.campaigns }
  const { brand, updateCampaignId, step } = useContext(CampaignFormContext)

  const steps = [
    {
      title: languageTexts.campaign_form_header_title_1({ updateCampaignId }),
      desc: languageTexts.campaign_form_header_desc_1({ categoryId: brand.categoryId }),
    },
    {
      title: languageTexts.campaign_form_header_title_2({ updateCampaignId, categoryId: brand.categoryId }),
      desc: languageTexts.campaign_form_header_desc_1({ categoryId: brand.categoryId }),
    },
    {
      title: languageTexts.campaign_form_header_title_3({ updateCampaignId }),
      desc: languageTexts.campaign_form_header_desc_2({ categoryId: brand.categoryId }),
    },
  ]

  return (
    <div>
      <div className="flex flex-col gap-4 items-center">
        <div className="flex flex-row gap-4">
          {steps.map((_, index) => (
            <div key={`campaign-form-header-step-${index}`} className="flex flex-row gap-4">
              <div>
                <span
                  className={`font-bold text-base tracking-tighter text-center ${
                    index == step - 1 ? "text-black" : "opacity-30"
                  }`}
                >
                  {index + 1}
                </span>
              </div>

              {index != steps.length - 1 && <div className="opacity-10 border-b-2 border-black w-8 h-0 my-auto"></div>}
            </div>
          ))}
        </div>

        <div className="w-full flex flex-col justify-center gap-3">
          <p className="text-2xl font-bold text-center whitespace-pre-wrap">{`${languageTexts._step(step)}`}</p>
          <p className="text-2xl font-bold text-center whitespace-pre-wrap">{`${steps[step - 1].title}`}</p>
          {steps[step - 1].desc && (
            <p className="text-[#999999] text-sm leading-4 text-center">{steps[step - 1].desc}</p>
          )}
        </div>
      </div>

      {step === 1 && (
        <div className="flex flex-col gap-[40px]">
          <CampaignFormModificationGuide className="mt-[25px]" />
          {/* 과거 캠페인 정보 불러오기 모달 */}
          {!updateCampaignId && <CampaignFormPastCampaignsModal />}
        </div>
      )}

      {step === 2 && (
        <CampaignFormHeaderButton onClick={() => window.open(
          isJapanService() 
            ? "https://slashpage.com/nmodelin/glovv_guideline_jp"
            : "https://bit.ly/4h974X6"
          , "_blank"
        )}>
          {languageTexts.open_example_guideline_button_text}
        </CampaignFormHeaderButton>
      )}
    </div>
  )
}

export default CampaignFormHeader
